function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1533",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.154809,236.25531 c -3.186993,0 -5.770033,-2.58339 -5.770033,-5.77038 0,-3.18664 2.58304,-5.77039 5.770033,-5.77039 3.186642,0 5.770385,2.58375 5.770385,5.77039 0,3.18699 -2.583743,5.77038 -5.770385,5.77038 z m 0,-14.50269 c -4.97064,0 -9.000773,4.02978 -9.000773,9.00077 0,4.97099 9.000773,26.82417 9.000773,26.82417 0,0 9.001125,-21.85318 9.001125,-26.82417 0,-4.97099 -4.030133,-9.00077 -9.001125,-9.00077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1535",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.078146,242.50054 c -2.253545,2.25319 -5.906911,2.25354 -8.160456,0 -2.253897,-2.25355 -2.253897,-5.90726 0,-8.16046 2.252839,-2.25354 5.906911,-2.25354 8.160456,0 2.253191,2.25355 2.253191,5.90691 0,8.16046 z m -10.25525,-10.25525 c -3.51543,3.51543 -3.51543,9.2142 0,12.72928 3.514725,3.51508 25.331913,12.60299 25.331913,12.60299 0,0 -9.087556,-21.81684 -12.602986,-25.33227 -3.514725,-3.51508 -9.214202,-3.51508 -12.728927,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1537",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.832921,257.57756 c 0,3.18664 -2.583745,5.77038 -5.770386,5.77038 -3.1866405,0 -5.7707382,-2.58374 -5.7707382,-5.77038 0,-3.18665 2.5840977,-5.77039 5.7707382,-5.77039 3.186641,0 5.770386,2.58374 5.770386,5.77039 z m -14.5030462,0 c 0,4.97134 4.0301333,9.00077 9.0007712,9.00077 4.970991,0 26.824163,-9.00077 26.824163,-9.00077 0,0 -21.853172,-9.00078 -26.824163,-9.00078 -4.9706379,0 -9.0007712,4.02978 -9.0007712,9.00078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1539",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.07744,272.65457 c 2.253897,2.25355 2.253897,5.90691 0,8.16046 -2.252839,2.25354 -5.906911,2.25354 -8.15975,0 -2.253897,-2.25355 -2.253897,-5.90691 0,-8.16046 2.253545,-2.25354 5.906911,-2.25354 8.15975,0 z m -10.254544,10.25525 c 3.514725,3.51508 9.213497,3.51473 12.728927,0 3.51543,-3.51508 12.602986,-25.33226 12.602986,-25.33226 0,0 -21.817188,9.0879 -25.331913,12.60298 -3.51543,3.51508 -3.51543,9.2142 0,12.72928"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1541",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.154809,278.8998 c 3.186642,0 5.770385,2.58303 5.770385,5.77038 0,3.187 -2.583743,5.77039 -5.770385,5.77039 -3.186993,0 -5.770033,-2.58339 -5.770033,-5.77039 0,-3.18735 2.58304,-5.77038 5.770033,-5.77038 z m 0,14.50304 c 4.970992,0 9.000419,-4.03013 9.001125,-9.00077 0,-4.97099 -9.001125,-26.82451 -9.001125,-26.82451 0,0 -9.000773,21.85352 -9.000773,26.82451 0,4.97064 4.030133,9.00077 9.000773,9.00077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1543",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.231826,272.65457 c 2.253895,-2.25319 5.90691,-2.25354 8.160808,0 2.253544,2.25355 2.252837,5.90726 0,8.16046 -2.253898,2.25354 -5.906913,2.25354 -8.160808,0 -2.253192,-2.25355 -2.253192,-5.90691 0,-8.16046 z m 10.25525,10.25525 c 3.515429,-3.51508 3.514725,-9.2142 0,-12.72928 -3.515432,-3.51508 -25.332267,-12.60298 -25.332267,-12.60298 0,0 9.087909,21.81718 12.60334,25.33226 3.514725,3.51473 9.213495,3.51508 12.728927,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1545",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.477051,257.57756 c 0,-3.18629 2.583037,-5.77039 5.770737,-5.77039 3.186642,0 5.769681,2.58374 5.769681,5.77039 0,3.18699 -2.583039,5.77038 -5.769681,5.77038 -3.1877,0 -5.770737,-2.58339 -5.770737,-5.77038 z m 14.503045,0 c 0,-4.97135 -4.029778,-9.00078 -9.000418,-9.00078 -4.971344,0 -26.824869,9.00078 -26.824869,9.00078 0,0 21.853525,9.00077 26.824869,9.00077 4.97064,0 9.000418,-4.02978 9.000418,-9.00077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1547",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.231826,242.50019 c -2.253192,-2.25284 -2.253192,-5.90656 0,-8.16046 2.253895,-2.25319 5.90691,-2.25284 8.160808,3.4e-4 2.252837,2.25355 2.252837,5.90692 0,8.16011 -2.253898,2.25389 -5.906913,2.25389 -8.160808,0 z m 10.25525,-10.25455 c -3.515432,-3.51543 -9.214202,-3.51508 -12.728927,-3.5e-4 -3.515431,3.51543 -12.60334,25.33227 -12.60334,25.33227 0,0 21.816835,-9.08791 25.332267,-12.60334 3.514725,-3.51473 3.514725,-9.2135 0,-12.72858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1549",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.995411,237.87844 c -2.944282,1.2192 -6.31966,-0.1785 -7.539213,-3.12314 -1.219552,-2.94428 0.178506,-6.31966 3.122436,-7.53921 2.944284,-1.21955 6.320367,0.1785 7.539215,3.12314 1.219552,2.94428 -0.178506,6.31966 -3.122438,7.53921 z m -5.550252,-13.3992 c -4.592813,1.90253 -6.77298,7.16774 -4.871155,11.7602 1.902178,4.59281 18.581512,21.33812 18.581512,21.33812 0,0 -0.04763,-23.63435 -1.950157,-28.22681 -1.902177,-4.59246 -7.167033,-6.77369 -11.7602,-4.87151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1551",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.455698,249.41781 c -1.219552,2.94428 -4.594577,4.34234 -7.539213,3.12279 -2.9442825,-1.21956 -4.3423405,-4.59494 -3.1227885,-7.53922 1.2195525,-2.94428 4.5952825,-4.34269 7.5392135,-3.12279 2.944283,1.21955 4.342341,4.59493 3.122788,7.53922 z M 6.0568468,243.86755 c -1.9021775,4.59317 0.2783417,9.85802 4.8715082,11.7602 4.59246,1.90253 28.227161,1.94981 28.227161,1.94981 0,0 -16.746009,-16.67863 -21.33847,-18.58116 -4.592108,-1.90218 -9.8576685,0.27869 -11.7601992,4.87115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1553",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.455698,265.73695 c 1.219553,2.94429 -0.178505,6.31966 -3.122788,7.53922 -2.943931,1.2199 -6.319661,-0.17851 -7.5392135,-3.12244 -1.219552,-2.94428 0.178506,-6.32001 3.1227885,-7.53957 2.944636,-1.21955 6.319661,0.17886 7.539213,3.12279 z m -13.3988512,5.55026 c 1.9025307,4.59281 7.1673852,6.77333 11.7601992,4.87115 4.592461,-1.90218 21.33847,-18.5808 21.33847,-18.5808 0,0 -23.634701,0.0473 -28.227161,1.94945 -4.5931665,1.90217 -6.7736857,7.16738 -4.8715082,11.7602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1555",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.995411,277.27667 c 2.943932,1.21955 4.34199,4.59493 3.122438,7.53921 -1.219555,2.94428 -4.594931,4.34269 -7.539215,3.12314 -2.94393,-1.2199 -4.341988,-4.59528 -3.122436,-7.53956 1.219553,-2.94464 4.594931,-4.34235 7.539213,-3.12279 z m -5.550252,13.3992 c 4.593167,1.90218 9.858023,-0.27905 11.7602,-4.87151 1.902532,-4.59281 1.950157,-28.2268 1.950157,-28.2268 0,0 -16.679334,16.7453 -18.581512,21.33776 -1.90253,4.59281 0.278342,9.85767 4.871155,11.76055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1557",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.314911,277.27667 c 2.943932,-1.2192 6.319663,0.17815 7.539215,3.12314 1.219552,2.94393 -0.17921,6.31966 -3.123494,7.53886 -2.944283,1.2199 -6.318956,-0.17851 -7.538508,-3.12279 -1.220258,-2.94428 0.178504,-6.31966 3.122787,-7.53921 z m 5.5499,13.39885 c 4.59246,-1.90253 6.772982,-7.16739 4.871508,-11.75985 -1.902528,-4.59281 -18.580803,-21.33811 -18.580803,-21.33811 0,0 0.04657,23.63434 1.949095,28.2268 1.902532,4.59246 7.167033,6.77369 11.7602,4.87116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1559",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.854271,265.73695 c 1.2192,-2.94393 4.59458,-4.34234 7.539567,-3.12279 2.943931,1.21956 4.34199,4.59529 3.122438,7.53957 -1.219555,2.94428 -4.594932,4.34234 -7.539215,3.12244 -2.944283,-1.21956 -4.342342,-4.59458 -3.12279,-7.53922 z m 13.398855,5.55026 c 1.902529,-4.59282 -0.279048,-9.85767 -4.871508,-11.7602 -4.592109,-1.90218 -28.226102,-1.94945 -28.226102,-1.94945 0,0 16.74495,16.67862 21.33741,18.5808 4.59246,1.90218 9.857668,-0.27834 11.7602,-4.87115"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1561",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.854271,249.41745 c -1.219552,-2.94358 0.178507,-6.31931 3.12279,-7.53921 2.944283,-1.21955 6.31966,0.17921 7.539215,3.12314 1.219552,2.94464 -0.178507,6.31966 -3.122438,7.53922 -2.944987,1.21955 -6.320367,-0.17816 -7.539567,-3.12315 z m 13.398855,-5.54954 c -1.902532,-4.59282 -7.16774,-6.77334 -11.7602,-4.87151 -4.59246,1.90253 -21.33741,18.58116 -21.33741,18.58116 0,0 23.633993,-0.0473 28.226102,-1.94981 4.59246,-1.90218 6.774037,-7.16703 4.871508,-11.75984"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1563",
    style: {
      fill: "#005d04",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.314911,237.87809 c -2.944283,-1.2192 -4.343045,-4.59458 -3.123493,-7.53921 1.219551,-2.94429 4.595635,-4.34234 7.539214,-3.12244 2.944987,1.21955 4.343046,4.59458 3.123494,7.53886 -1.219552,2.94464 -4.595283,4.3427 -7.539215,3.12279 z m 5.5499,-13.3985 c -4.593167,-1.90253 -9.857668,0.2787 -11.7602,4.8708 -1.902529,4.59282 -1.949095,28.22717 -1.949095,28.22717 0,0 16.678275,-16.74531 18.580097,-21.33812 1.90218,-4.59246 -0.278342,-9.85732 -4.870802,-11.75985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1565",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.154809,245.8297 c -1.755775,0 -3.179233,-1.42346 -3.179233,-3.17923 0,-1.75578 1.423458,-3.17923 3.179233,-3.17923 1.756127,0 3.179585,1.42345 3.179585,3.17923 0,1.75577 -1.423458,3.17923 -3.179585,3.17923 z m 0,-7.99041 c -2.738966,0 -4.958998,2.22038 -4.958998,4.95899 0,2.73897 4.958998,14.77928 4.958998,14.77928 0,0 4.95935,-12.04031 4.95935,-14.77928 0,-2.73861 -2.220735,-4.95899 -4.95935,-4.95899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1567",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.847951,249.2707 c -1.241778,1.24142 -3.254375,1.24142 -4.4958,0 -1.241778,-1.24178 -1.241778,-3.25473 0,-4.49616 1.241425,-1.24177 3.254022,-1.24177 4.4958,0 1.241425,1.24143 1.241425,3.25473 0,4.49616 z m -5.650089,-5.65009 c -1.93675,1.93675 -1.93675,5.07612 0,7.01322 1.93675,1.9364 13.956947,6.94373 13.956947,6.94373 0,0 -5.007327,-12.0202 -6.943373,-13.95695 -1.93675,-1.93675 -5.076824,-1.93675 -7.013574,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1569",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.406957,257.57756 c 0,1.75577 -1.423459,3.17923 -3.179234,3.17923 -1.755422,0 -3.179233,-1.42346 -3.179233,-3.17923 0,-1.75578 1.423811,-3.17924 3.179233,-3.17924 1.755775,0 3.179234,1.42346 3.179234,3.17924 z m -7.990417,0 c 0,2.73896 2.220383,4.95899 4.95935,4.95899 2.738967,2.7e-4 14.778919,-4.95899 14.778919,-4.95899 0,0 -12.039952,-4.959 -14.778919,-4.95935 -2.738967,0 -4.95935,2.22073 -4.95935,4.95935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1571",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.847951,265.88477 c 1.241425,1.24142 1.241425,3.25437 0,4.4958 -1.241778,1.24178 -3.254375,1.24178 -4.4958,0 -1.241778,-1.24143 -1.241778,-3.25438 0,-4.4958 1.241425,-1.24178 3.254022,-1.24178 4.4958,0 z m -5.650089,5.65009 c 1.93675,1.93675 5.07612,1.93639 7.01287,0 1.93675,-1.93675 6.944077,-13.9573 6.944077,-13.9573 0,0 -12.020197,5.00732 -13.956947,6.94372 -1.93675,1.9371 -1.93675,5.07683 0,7.01358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1573",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.154809,269.32576 c 1.756127,0 3.179585,1.42311 3.179585,3.17888 0,1.75613 -1.423458,3.17923 -3.179585,3.17923 -1.755775,0 -3.179233,-1.4231 -3.179233,-3.17923 0,-1.75577 1.423458,-3.17923 3.179233,-3.17888 z m 0,7.99006 c 2.738615,0 4.95935,-2.22038 4.95935,-4.95899 0,-2.73897 -4.95935,-14.77927 -4.95935,-14.77927 0,0 -4.958998,12.0403 -4.958998,14.77927 0,2.73861 2.220032,4.95899 4.958998,4.95899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1575",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.462374,265.88477 c 1.240719,-1.24178 3.25402,-1.24178 4.4958,0 1.241425,1.24142 1.241425,3.25437 0,4.4958 -1.24178,1.24178 -3.254375,1.24178 -4.4958,0 -1.242483,-1.24143 -1.242483,-3.25438 0,-4.4958 z m 5.649735,5.65009 c 1.93675,-1.93675 1.93675,-5.07648 0,-7.01358 -1.93675,-1.9364 -13.9573,-6.94372 -13.9573,-6.94372 0,0 5.006975,12.02055 6.943725,13.9573 1.937102,1.93639 5.076825,1.93639 7.013575,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1577",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.903016,257.57756 c 0,-1.75578 1.423103,-3.17924 3.179233,-3.17924 1.755775,0 3.179231,1.42346 3.179231,3.17924 0,1.75612 -1.423456,3.17923 -3.179231,3.17923 -1.75613,0 -3.17994,-1.42311 -3.179233,-3.17923 z m 7.990062,0 c 0,-2.73897 -2.220032,-4.959 -4.958996,-4.95935 -2.738614,2.6e-4 -14.779273,4.95935 -14.779273,4.95935 0,0 12.040659,4.95935 14.779273,4.95899 2.738964,0 4.958996,-2.22003 4.958996,-4.95899"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1579",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.462374,249.27034 c -1.24178,-1.24107 -1.242483,-3.25437 0,-4.49615 1.241425,-1.24142 3.25402,-1.24107 4.4958,3.5e-4 1.241425,1.24177 1.241425,3.25437 0,4.4958 -1.24178,1.24177 -3.254375,1.24177 -4.4958,0 z m 5.649735,-5.64973 c -1.93675,-1.93675 -5.076473,-1.93675 -7.013575,-3.5e-4 -1.93675,1.93711 -6.943725,13.9573 -6.943725,13.9573 0,0 12.02055,-5.00732 13.9573,-6.94407 1.93675,-1.93675 1.93675,-5.07612 0,-7.01287"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1581",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.659361,246.72399 c -1.622425,0.67169 -3.482268,-0.0984 -4.153958,-1.72049 -0.671687,-1.62243 0.09842,-3.48192 1.720498,-4.15396 1.622073,-0.67169 3.482268,0.0984 4.153958,1.7205 0.672042,1.62207 -0.09842,3.48191 -1.720498,4.15395 z m -3.057525,-7.38258 c -2.530827,1.04846 -3.73274,3.949 -2.684638,6.47947 1.048809,2.53048 10.238318,11.75668 10.238318,11.75668 0,0 -0.02646,-13.02174 -1.074209,-15.55221 -1.048808,-2.53048 -3.9497,-3.73204 -6.479471,-2.68394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1583",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.301248,253.08211 c -0.671689,1.62172 -2.531533,2.39219 -4.153958,1.7205 -1.622072,-0.6724 -2.392539,-2.53189 -1.720497,-4.15396 0.671689,-1.62208 2.531886,-2.39289 4.153958,-1.72085 1.622072,0.67204 2.392892,2.53188 1.720497,4.15431 z m -7.382227,-3.05823 c -1.04775,2.53047 0.153811,5.43136 2.683933,6.47947 2.530828,1.0481 15.552562,1.07421 15.552562,1.07421 0,0 -9.226905,-9.18916 -11.757026,-10.23762 -2.530475,-1.0481 -5.431367,0.15346 -6.479469,2.68394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1585",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.301248,262.073 c 0.671689,1.62243 -0.09843,3.48227 -1.720497,4.15396 -1.622072,0.67204 -3.481564,-0.0984 -4.153958,-1.7205 -0.672042,-1.62207 0.09842,-3.48191 1.720497,-4.15395 1.622425,-0.67205 3.482269,0.0984 4.153958,1.72049 z m -7.382227,3.05788 c 1.048102,2.53083 3.948994,3.73204 6.479469,2.68393 2.530121,-1.04775 11.757026,-10.23725 11.757026,-10.23725 0,0 -13.021734,0.0261 -15.552562,1.07385 -2.530122,1.0481 -3.731683,3.94935 -2.683933,6.47947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1587",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.659361,268.43112 c 1.622073,0.67204 2.39254,2.53153 1.720498,4.15395 -0.672393,1.62208 -2.531885,2.39254 -4.153958,1.7205 -1.622073,-0.67204 -2.392185,-2.53188 -1.720498,-4.15396 0.67169,-1.62207 2.531533,-2.39254 4.153958,-1.72049 z m -3.057525,7.38222 c 2.529771,1.04811 5.430663,-0.15346 6.478765,-2.68358 1.048456,-2.53047 1.074915,-15.5522 1.074915,-15.5522 0,0 -9.189509,9.22619 -10.238318,11.75631 -1.048102,2.53048 0.153811,5.43137 2.684638,6.47947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1589",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.650609,268.43112 c 1.622425,-0.67169 3.482269,0.0984 4.153959,1.72049 0.672041,1.62208 -0.09842,3.48192 -1.720499,4.15396 -1.622425,0.67204 -3.482268,-0.0984 -4.153958,-1.7205 -0.671687,-1.62242 0.09842,-3.48191 1.720498,-4.15395 z m 3.057877,7.38222 c 2.53083,-1.0481 3.731683,-3.94899 2.684288,-6.47947 -1.048456,-2.53047 -10.237258,-11.75631 -10.237258,-11.75631 0,0 0.0254,13.02138 1.073502,15.5522 1.048456,2.53012 3.949348,3.73169 6.479468,2.68358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1591",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.008724,262.073 c 0.672042,-1.62172 2.531533,-2.39254 4.15431,-1.72049 1.621719,0.67204 2.392185,2.53188 1.719792,4.15395 -0.672042,1.62208 -2.531533,2.39254 -4.153607,1.7205 -1.622425,-0.67169 -2.392891,-2.53153 -1.720495,-4.15396 z m 7.382227,3.05788 c 1.048102,-2.53047 -0.153813,-5.43101 -2.683582,-6.47912 -2.530826,-1.0481 -15.551853,-1.0742 -15.551853,-1.0742 0,0 9.225843,9.18915 11.755966,10.23725 2.530827,1.04811 5.431364,-0.15345 6.479469,-2.68393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1593",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.008724,253.08176 c -0.67169,-1.62208 0.09807,-3.48192 1.720495,-4.15396 1.622074,-0.67204 3.481565,0.0988 4.153607,1.72085 0.672393,1.62207 -0.09807,3.48156 -1.720498,4.1536 -1.622071,0.67205 -3.481562,-0.0981 -4.153604,-1.72049 z m 7.382227,-3.05788 c -1.048105,-2.53048 -3.948642,-3.73204 -6.479469,-2.68394 -2.530123,1.04811 -11.755966,10.23762 -11.755966,10.23762 0,0 13.021027,-0.0257 15.551853,-1.07456 2.529769,-1.04775 3.731684,-3.94865 2.683582,-6.47912"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1595",
    style: {
      fill: "#a5871e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.650609,246.72364 c -1.622073,-0.67169 -2.392185,-2.53153 -1.720498,-4.1536 0.67169,-1.62243 2.53224,-2.39219 4.153958,-1.7205 1.622074,0.67204 2.39254,2.53153 1.720499,4.1536 -0.67169,1.62243 -2.531534,2.39254 -4.153959,1.7205 z m 3.057877,-7.38223 c -2.53012,-1.04775 -5.431012,0.15346 -6.479468,2.68394 -1.048102,2.53047 -1.073502,15.55221 -1.073502,15.55221 0,0 9.188802,-9.2262 10.236552,-11.75668 1.048101,-2.53047 -0.152752,-5.43101 -2.683582,-6.47947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1597",
    style: {
      fill: "#5b0e1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.424501,257.57756 c 0,4.01461 -3.254727,7.26933 -7.269692,7.26933 -4.014258,0 -7.26934,-3.25472 -7.26934,-7.26933 0,-4.01461 3.255082,-7.26934 7.26934,-7.26934 4.014965,0 7.269692,3.25472 7.269692,7.26934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower16);
export default __webpack_public_path__ + "static/media/flower-16.4001ca6df97e8a4d48732d51d7e444ba.svg";
export { ForwardRef as ReactComponent };